export enum CompanyStatus {
  WAITING_FOR_EVALUATION = 0,
  EVALUATED = 1,
  NEEDS_MORE_INFO = 2,
  EVALUATION_IN_PROGRESS = 3,
  ERROR = 4,
  GATHERING_DIGITAL_PERFORMANCE = 5,
  FETCHING_COMPANY_DETAILS = 6,
  PROCESSING_COMPANY_INFORMATIONS = 7,
  GRADING_COMPANY = 8,
  TIME_LIMIT_EXCEEDED = 9,
}
export enum EvaluationStatus {
  EVALUATED = 1,
  NEEDS_MORE_INFO = 2,
  EVALUATION_IN_PROGRESS = 3,
  ERROR = 4,
  GATHERING_DIGITAL_PERFORMANCE = 5,
  FETCHING_COMPANY_DETAILS = 6,
  PROCESSING_COMPANY_INFORMATIONS = 7,
  GRADING_COMPANY = 8,
  TIME_LIMIT_EXCEEDED = 9,
  INITIALIZED = 10,
  PAUSED = 11,
}

export enum FilteredContentCase {
  ALL = 0,
  ABOUT = 1,
  DOCUMENT = 2,
  WEBSITE = 3,
}

export enum UserRole {
  USER = 0,
  ADMIN = 1,
}

export enum ModelLevel {
  BASIC = 0,
  ENTRY = 1,
  FULL = 2,
}

export enum ProcessingStatus {
  WAITING = 0,
  IN_PROGRESS = 1,
  PROCESSED = 2,
  ERROR = 3,
  TIME_LIMIT_EXCEEDED = 4,
  STOPPED = 5,
}

export enum DocumentType {
  TXT = 0,
  WORD = 1,
  PDF = 2,
  POWERPOINT = 3,
  IMAGE = 4,
}

export enum KnowledgeBaseStatus {
  WAITING = 0,
  IN_PROGRESS = 1,
  PROCESSED = 2,
  ERROR = 3,
  TIME_LIMIT_EXCEEDED = 4,
  STOPPED = 5,
}

export enum Features {
  ORDER_AN_EXPERT = 1,
  DUSMANN_IMPORT = 2,
  QUESTION_LISTS = 3,
  EVALUATION = 4,
  KNOWLEDGE_BASE_SOURCES = 5,
  FILTERED_CONTENT = 7,
  QA_INSIGHTS = 8,
  EXPERT_CONSULTATION = 9,
  EVALUATION_CONFIG_OVERRIDE = 10,
  COMO_EXPERTS = 11,
  ENTITY_CREATION = 12,
  VOICES_MARKETING = 13,
  VOICES_POSTING = 14,
  HELP_DESK = 15,
  AMBASSADOR = 16,
  AMBASSADOR_DEAL_MANAGEMENT = 17,
  AMBASSADOR_NEWS = 18,
  COMO_EXTERNAL_LINKS = 19,
  DOCUMENT_CRAFTING = 20,
}

export const USER_ONLY_FEATURES = [
  Features.VOICES_MARKETING,
  Features.VOICES_POSTING,
  Features.AMBASSADOR_DEAL_MANAGEMENT,
  Features.AMBASSADOR_NEWS,
];

export enum Languages {
  ENGLISH = 0,
  GERMAN = 1,
  SERBIAN = 2,
  GREEK = 3,
  HUNGARIAN = 4,
  JAPANESE = 5,
}

export enum Steps {
  SELECT_COMPANY = 0,
  SELECT_MODEL = 1,
  SELECT_CERTFICATION_CATEGORY = 2,
  SELECT_QUESTION_LIST = 3,
  SELECT_ANNEX = 4,
  EVALUATION = 5,
}

export enum WorkspaceTerminology {
  DEFAULT = 0,
  POWERPLANT = 1,
  COMPANY = 2,
  PRODUCT = 3,
  DEVICE = 4,
  PROJECT = 5,
}

export enum LoginMethod {
  PASSWORD = 0,
  ENTRA_ID = 1,
}
